import axios from "axios";

export async function getContainers({ commit }, payload) {
  try {
    const { data } = await axios.post(`containers/codes`, payload);
    return data;
  } catch (e) {
    return e;
  }
}
